<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card class="pa-3">
            <p class=".title ma-2">Copy discount(s)</p>
            <v-form ref="copyHsab" v-model="copyHsabValid">
                <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <td></td>
                            <td>Stay within</td>
                            <td>Booking within</td>
                            <td>% Guest</td>
                            <td>% Host</td>
                          </tr>
                        </thead>    
                        <tbody>                  
                          <tr v-for="(hsabRecord,i) in hsabRecords" :key="i">
                           <td><v-checkbox
                                    v-model="selectedHsab"
                                    :value="hsabRecord.hsab_encrid"
                                    
                                ></v-checkbox></td>
                           <td>{{hsabRecord.hsab_verb}}</td>
                           <td>{{hsabRecord.hsab_boek}}</td>
                           <td>{{hsabRecord.hsab_kort_perc_verkoop}}%</td>
                           <td>{{hsabRecord.hsab_kort_perc_inkoop}}%</td>
                          </tr>
                          
                          <tr v-if="lmdc_nr > 0">
                            <td>
                            <v-checkbox
                                    v-model="selectedLmdc"
                                    :value="lmdc_nr"
                                ></v-checkbox></td>
                            <td>Current last-minute discount:</td>
                            <td colspan="4" class="text-center"><span v-for="(lm_line, lml) in lm_choices.find(({ nr }) => nr === lmdc_nr).lines.slice().reverse()" :key="lml">
                            <b>{{ lm_line.days_from }} - {{ lm_line.days_to }}</b> days before arival <b>{{ lm_line.perc }}%</b> <br>
                        </span></td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>

            <v-row no-gutters>
                <v-col class="pa-2">
                    <v-autocomplete
                        v-model="to_huis_codes"
                        :items="items"
                        :loading="isLoading"
                        :search-input.sync="search"
                        :rules="to_huis_codes_checks"
                        cache-items
                        filled
                        chips
                        color="blue-grey lighten-2"
                        label="Start typing accommodation codes (search starts after 3 characters)"
                        item-text="huis_code"
                        item-value="huis_code"
                        multiple
                        dense
                        >
                        <template v-slot:selection="data">
                            <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="remove(data.item)"
                            >
                            <v-icon left>
                                mdi-home
                            </v-icon>
                            {{ data.item.huis_code }}
                            </v-chip>
                        </template>
                        <template v-slot:item="data">
                            <v-list-item-avatar>
                            <v-icon left>
                                mdi-home
                            </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                            <v-list-item-title v-text="data.item.huis_code"></v-list-item-title>
                            <v-list-item-subtitle v-text="data.item.huis_naam"></v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
            </v-autocomplete>
                </v-col>
            </v-row>

            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="copyHsab()" :disabled="!copyHsabValid">Copy</v-btn>
                <v-btn color="primary" small @click="closeDialog()">Close</v-btn>
            </v-card-actions>
        </v-card>
        <standard_dialog ref="standard_dialog" /> 
    </v-dialog>
</template>

<script>

// import { bus } from "../../../main";
import standard_dialog from '@/components/ui/standard_dialog.vue';

export default {

    data() {
        return {
            dialog: false,
            copyHsabValid: false,
            hsab_encrid: null,
            to_huis_codes: [],
            to_huis_codes_checks: [
                v => !!v || 'Accommodation codes are required',
            ],
            hsab_verb: null,
            hsab_boek: null,
            hsab_advb: null,
            hsab_aant_nacht: null,
            hsab_dag: null,
            hsab_kort_perc_inkoop: null,
            hsab_kort_perc_verkoop: null,
            isLoading: false,
            items: [],
            model: null,
            search: null,
            hsabRecord: null,
            hsabRecords: null,
            lm_choices: null,
            lmdc_nr: null,
            selectedHsab: [],
            selectedLmdc: [],
        }
    },
    components: {
        standard_dialog,
    },
    watch: {
        search (val) {
            this.isLoading = true
            if (val.length >= 3) {
                this.$axios
                    .post("ares/json/ares/huis/hsab/searchHuis.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "searchHuis"
                        },
                        searchHuis: {
                            huis_code: val
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.items = res.data.searchHuis.huizen;
                        }
                    })
                    .finally(() => {
                        this.isLoading = false
                    });
                }
            else {
                this.isLoading = false
            }
        }
    },
    methods: {
        updateData(data){
            //console.log('updateData', data);
            this[data.field] = data.value;
        },
        closeDialog(){
            this.$refs.copyHsab.reset();
            this.$emit("closeDialog");
            this.dialog = false;
        },
        open(hsabRecords,lm_choices,lmdc_nr) {
            // console.log(hsabRecords);
            // console.log(lm_choices);
            // console.log(lmdc_nr);
            
            this.$emit("showSnackbar");        
            this.hsabRecords = hsabRecords;
            this.lm_choices = lm_choices;
            this.lmdc_nr = lmdc_nr;
            this.to_huis_codes = [];
            this.selectedHsab = [];
            this.dialog = true;
            
            
            
            this.$axios
                .post("ares/json/ares/huis/hsab/searchHuis.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "searchHuisOfOwner"
                        },
                        searchHuis: {
                            hsab_encrid: hsabRecords[0].hsab_encrid // dit klopt niet
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.items = res.data.searchHuis.huizen;
                        }
                    })
                    .finally(() => {
                        this.isLoading = false
                    });
              
        },
        copyHsab() {
            this.$axios
                .post("ares/json/ares/huis/hsab/copyHsab.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "copyHsab"
                    },
                    copyHsab: {
                        to_huis_codes: this.to_huis_codes,
                        hsab_encrids: this.selectedHsab,
                        lmdc_nr: this.selectedLmdc,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "warning"
                        });
                        console.log(res.data.error);
                    } else {
                        // if (res.data.copyHsab.color == "success") {
                        //     bus.$emit("closeDialog", "reload");
                        // }
                        this.$refs.standard_dialog.setWidth(900);
                        this.$refs.standard_dialog.setTextClass("text-center text-body-1 pa-12");
                        this.$refs.standard_dialog.open(res.data.copyHsab.color, res.data.copyHsab.caption , res.data.copyHsab.text); 
                        this.closeDialog();
                    }
                })
        },
        remove(item){
            console.log(item)
            const index = this.to_huis_codes.indexOf(item.huis_code)
            if (index >= 0) this.to_huis_codes.splice(index, 1)
        }
    }
}
</script>

